/**
 * Stub engines — Cross-Sell, Upsell, Retention, Referral, Prospecting.
 * (Renewal fue activado — ver domain/engines/renewal.js.)
 *
 * Each returns a minimal object satisfying the same shape as recovery.js.
 * When activating a new engine:
 *   1. Move its factory into its own file (e.g. /engines/renewal.js).
 *   2. Wire it in application/container.js.
 *   3. Change its status in /config/engines.js to "live".
 *
 * The UI will pick it up automatically.
 */

/**
 * @param {string} engineId
 * @param {{label: string, question: string, status: string}} meta
 */
export function makeStubEngine(engineId, meta) {
  return function createStub(/* deps */) {
    const empty = async () => [];
    return {
      id: engineId,
      async evaluateActor() { /* no-op */ },
      async listOpportunities() { return []; },
      async getOpportunity() { return null; },
      async recordOutcome() { throw new Error(`${engineId.toUpperCase()}_ENGINE_NOT_ACTIVATED`); },
      async regeneratePlay() { throw new Error(`${engineId.toUpperCase()}_ENGINE_NOT_ACTIVATED`); },
      async updatePlayBody() { throw new Error(`${engineId.toUpperCase()}_ENGINE_NOT_ACTIVATED`); },
      async getMetrics() {
        return {
          dormantValue: { amount: 0, currency: "USD" },
          awakeValue: { amount: 0, currency: "USD" },
          opportunitiesPending: 0, opportunitiesWon: 0, opportunitiesLost: 0,
          winRate: 0, avgWindowDays: 0,
          priorityBreakdown: { high: 0, medium: 0, low: 0 },
        };
      },
      async getSummary() {
        return {
          id: engineId,
          label: meta.label,
          question: meta.question,
          status: meta.status,
          potentialValue: null,
          actorsCount: 0,
          opportunitiesCount: 0,
          recentClosedValueUsd: 0,
        };
      },
    };
  };
}

export const createCrossSellEngine = makeStubEngine("cross_sell", {
  label: "Cross-Sell",
  question: "¿A qué cliente puedo venderle algo que ya está listo para comprar?",
  status: "coming_soon",
});
export const createUpsellEngine = makeStubEngine("upsell", {
  label: "Upsell",
  question: "¿Qué clientes están saturados y listos para pagar más?",
  status: "coming_soon",
});
export const createRetentionEngine = makeStubEngine("retention", {
  label: "Retention",
  question: "¿Qué clientes están por irse y aún puedo salvar?",
  status: "coming_soon",
});
export const createReferralEngine = makeStubEngine("referral", {
  label: "Referral",
  question: "¿Cuál de mis clientes felices puede traerme el siguiente cliente?",
  status: "coming_soon",
});
export const createProspectingEngine = makeStubEngine("prospecting", {
  label: "Prospecting",
  question: "¿Qué prospectos se parecen a mis mejores clientes?",
  status: "coming_soon",
});
